import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button, Notification, Tooltip } from '@xsolla/ui-core';
import { AlertExclamationColorful } from '@xsolla/ui-icons';

import { SocialConnection } from '../../../api';
import { SocialIconsList } from '../../index';
import { Notice } from '../../ui';
import { AdditionalSocialSettings } from './AdditionalSocialSettings';
import {
  SocialSettingsBlock,
  SocialSettingsSubtitle,
  SocialSettingsTitle,
  SocialSettingsTitleBlock,
  TitleIconWrapper
} from './style';

type Props = {
  socialSettings: SocialConnection;
  setSocialSettings: React.Dispatch<React.SetStateAction<SocialConnection>>;
};

const OAuth2Callback = 'https://login.xsolla.com/api/social/oauth2/callback';
const OAuthCallback = 'https://login.xsolla.com/api/social/oauth/callback';
const BabkaSocialName = 'babka';
const XsollaIdSocialName = 'xsolla-id';
const TwitterSocialName = 'twitter';

const SocialSettingsHeader = ({ socialSettings, setSocialSettings }: Props): JSX.Element => {
  const intl = useIntl();

  const isXsollaKeys = useMemo(
    () =>
      socialSettings.configurable_fields.length &&
      socialSettings.configurable_fields[0].value === null &&
      socialSettings.configurable_fields[1]?.value === null,
    [socialSettings.configurable_fields]
  );

  return (
    <>
      <SocialSettingsTitleBlock>
        <TitleIconWrapper>{SocialIconsList[socialSettings.provider]}</TitleIconWrapper>
        {socialSettings.provider !== 'twitter' && (
          <SocialSettingsTitle>
            {intl.messages[`auth-methods.${socialSettings.provider}`]}
          </SocialSettingsTitle>
        )}
        {socialSettings.connected &&
          isXsollaKeys &&
          socialSettings.provider !== XsollaIdSocialName && (
            <Tooltip content={intl.messages['social-connection.card.tooltip']}>
              <Button look="icon" palette="brand">
                <AlertExclamationColorful size={16} />
              </Button>
            </Tooltip>
          )}
      </SocialSettingsTitleBlock>
      <SocialSettingsSubtitle>
        {intl.messages['social-connection.settings.subtitle']}
      </SocialSettingsSubtitle>

      {socialSettings.provider !== BabkaSocialName &&
        socialSettings.provider !== XsollaIdSocialName && (
          <SocialSettingsBlock>
            <Notification palette="brand" icon={Notice}>
              <FormattedMessage
                id="social-connection.settings.notification"
                values={{
                  br: () => <br />,
                  link:
                    socialSettings.provider === TwitterSocialName ? OAuthCallback : OAuth2Callback
                }}
              />
            </Notification>
          </SocialSettingsBlock>
        )}

      <AdditionalSocialSettings
        socialSettings={socialSettings}
        setSocialSettings={setSocialSettings}
      />
    </>
  );
};

export default SocialSettingsHeader;
